var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "pt-5 pb-5 is-max-desktop",
      attrs: { id: "evaluation-panel" },
    },
    [
      _c("EvaluationBreadcrumb", { attrs: { links: _vm.links } }),
      !_vm.isLoadingEvaluation
        ? _c(
            "div",
            [
              _c("EvaluationHeader", { attrs: { debtor: _vm.debtor } }),
              _c(
                "main",
                {
                  staticClass: "block mt-4",
                  attrs: { id: "evaluation-steps" },
                },
                [
                  _c("header", { staticClass: "summary-header" }, [
                    _c(
                      "article",
                      { attrs: { id: "summary-client" } },
                      [
                        _vm.evaluation &&
                        _vm.evaluation.applicationDate !== "" &&
                        _vm.evaluation.applicationDate !== null &&
                        _vm.evaluation.applicationDate !== "0000-00-00"
                          ? _c(
                              "b-tag",
                              {
                                attrs: {
                                  type: "is-primary is-bg-transparent mr-4",
                                  icon: "calendar-days",
                                  "data-cy": "birthdate",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.formatDate(
                                        _vm.evaluation.applicationDate
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "b-tag",
                          {
                            attrs: {
                              type: "is-primary is-bg-transparent mr-4",
                              icon: "location-arrow",
                              "data-cy": "simulationOrigin",
                              rounded: "",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.evaluation.simulationOrigin) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "b-tag",
                          {
                            attrs: {
                              type: "is-primary is-bg-transparent mr-4",
                              icon:
                                _vm.evaluation.type === "automatic"
                                  ? "robot"
                                  : "circle-user",
                              "data-cy": "automatic",
                              rounded: "",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.evaluation.type === "automatic"
                                    ? "Automática"
                                    : "Manual"
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "b-tag",
                          {
                            attrs: {
                              type: "is-primary is-bg-transparent mr-4",
                              icon: _vm.evaluation.future
                                ? "hourglass-start"
                                : "bolt",
                              "data-cy": "future",
                              rounded: "",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.evaluation.future ? "Futura" : "Inmediata"
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm.evidenceData.length > 0
                      ? _c(
                          "article",
                          { staticClass: "evaluations-documents" },
                          _vm._l(_vm.evidenceData, function (document, i) {
                            return _c(
                              "b-button",
                              {
                                key: i,
                                attrs: {
                                  size: "is-small",
                                  type: "mr-4",
                                  "icon-left": "download",
                                  tag: "a",
                                  href: `data:application/pdf;base64,${document.pdfBase64}`,
                                  download: document.pdfFileName,
                                  rounded: "",
                                },
                              },
                              [_vm._v(" " + _vm._s(document.pdfFileName) + " ")]
                            )
                          }),
                          1
                        )
                      : _vm._e(),
                  ]),
                  _c(
                    "section",
                    {
                      staticClass: "step-content box",
                      attrs: { id: "evaluations-resume" },
                    },
                    [
                      _c("Resume", {
                        staticClass: "mb-5",
                        attrs: { evaluation: _vm.evaluation },
                      }),
                      _c(
                        "b-button",
                        {
                          staticClass: "is-secondary",
                          attrs: {
                            id: "btn-home",
                            outlined: "",
                            tag: "router-link",
                            to: {
                              name: "evaluation-detail",
                              params: {
                                evaluationId: _vm.getParentEvaluationId(),
                              },
                            },
                            type: "is",
                            "icon-pack": "fas",
                            "icon-left": "chevron-left",
                            "data-cy": "btn-home",
                          },
                        },
                        [_vm._v(" Regresar ")]
                      ),
                      _vm.isReadyForRatify()
                        ? _c(
                            "b-button",
                            {
                              staticClass: "is-pulled-right",
                              attrs: {
                                type: "is-danger",
                                "icon-pack": "fas",
                                "icon-right": "chevron-right",
                                "data-cy": "ratifyButton",
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.enableShowConfirmation.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [_vm._v(" Ratificar ")]
                          )
                        : _vm._e(),
                      _vm.showConfirmation
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "is-flex-desktop is-align-items-center is-pulled-right",
                              attrs: { "data-cy": "confirmation-dialog" },
                            },
                            [
                              _c("p", { staticClass: "is-pulled-left mr-4" }, [
                                _vm._v(
                                  "¿Seguro quieres ratificar la verificación?"
                                ),
                              ]),
                              _c(
                                "b-button",
                                {
                                  attrs: {
                                    type: "is-danger",
                                    "data-cy": "button-confirm",
                                  },
                                  on: { click: _vm.ratify },
                                },
                                [_vm._v("Sí")]
                              ),
                              _c(
                                "b-button",
                                {
                                  attrs: {
                                    type: "is-text",
                                    "data-cy": "button-cancel",
                                  },
                                  on: { click: _vm.cancelRatification },
                                },
                                [_vm._v(" No ")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.isLoadingEvaluation ? _c("Spinner") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }